module.exports = __webpack_public_path__ + "static/media/interventions.b05b42ab.svg";